module.exports = __webpack_public_path__ + "static/media/Projets-Villas-Vaud.f996d281.jpg";